(function () {
  'use strict';

  angular.module('app').component('hotelPriceDetail', hotelPriceDetail());

  function hotelPriceDetail() {
    return {
      bindings: {
        hotelPrices: '=',
        hotel: '=',
        seasonSelected: '=',
        priceListSelected: '=',
        onHotelPricesSaved: '&',
        onHotelPricesCanceled: '&',
      },
      controller: HotelPriceDetailComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/hotel-prices/hotel-price-detail/hotel-price-detail.component.html',
    };
  }

  HotelPriceDetailComponent.$inject = ['CONFIGURATIONS', 'UtilService', 'HotelPriceService'];

  function HotelPriceDetailComponent(config, UtilService, HotelPriceService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.dateDisplay = config.DATE_DISPLAY;

    vm.saveHotelPrices = saveHotelPrices;
    vm.cancel = cancel;

    vm.$onInit = function () {
      if (vm.hotelPrices.length > 0) {
        // Edit and exists prices
        setItemOptions(vm.hotelPrices[0].updated_at);
      } else {
        // Create
        vm.lastUpdatedAt = false;

        vm.saveButtonLabel = 'SAVE_PRICES';
      }

      setHotelPricesData();
    };

    function setItemOptions(updateAt) {
      vm.editMode = true;

      vm.lastUpdatedAt = updateAt;
      vm.saveButtonLabel = 'UPDATE_PRICES';
    }

    function setHotelPricesData() {
      vm.hotelPricesData = [];

      vm.hotel.hotel_rooms.forEach(function (hotelRoom) {
        if (hotelRoom.status === 'active') {
          var hotelPriceId;
          var singlePrice = '',
            doublePrice = '';
          var triplePrice = 0,
            quadruplePrice = 0,
            additionalPersonPrice = 0,
            childPrice = 0;
          var hotelPrice;

          // Exist hotel prices
          if (vm.hotelPrices.length > 0) {
            for (var i = 0; i < vm.hotelPrices.length; i++) {
              hotelPrice = vm.hotelPrices[i];

              if (hotelPrice.hotel_room_id === hotelRoom.id) {
                hotelPriceId = hotelPrice.id;

                singlePrice = hotelPrice.single_price;
                doublePrice = hotelPrice.double_price;
                triplePrice = hotelPrice.triple_price;
                quadruplePrice = hotelPrice.quadruple_price;
                additionalPersonPrice = hotelPrice.additional_person_price;
                childPrice = hotelPrice.child_price;
                break;
              }
            }
          }

          hotelPrice = {
            room: {
              id: hotelRoom.id,
              name: hotelRoom.name,
              max_occupancy: hotelRoom.max_occupancy,
              children_allowed: hotelRoom.children_allowed,
              status: hotelRoom.status,
            },
            single_price: singlePrice,
            double_price: doublePrice,
            triple_price: triplePrice,
            quadruple_price: quadruplePrice,
            additional_person_price: additionalPersonPrice,
            child_price: childPrice,
          };

          if (hotelPriceId) {
            hotelPrice.hotelPriceId = hotelPriceId;
          }

          vm.hotelPricesData.push(hotelPrice);
        }
      });

      return vm.hotelPricesData;
    }

    function saveHotelPrices(isFormValid) {
      if (!isFormValid || vm.hotelPricesData.length === 0) {
        return;
      }

      var hotelPrices = [];

      vm.hotelPricesData.forEach(function (hotelPrice) {
        var price = {
          single_price: hotelPrice.single_price || 0,
          double_price: hotelPrice.double_price || 0,
          triple_price: hotelPrice.triple_price || 0,
          quadruple_price: hotelPrice.quadruple_price || 0,
          additional_person_price: hotelPrice.additional_person_price || 0,
          child_price: hotelPrice.child_price || 0,

          hotel_room_id: hotelPrice.room.id,
          id: null,
        };

        if (hotelPrice.hotelPriceId) {
          price.id = hotelPrice.hotelPriceId;
        }

        hotelPrices.push(price);
      });

      var params = {
        hotel_prices: hotelPrices,
        price_list_id: vm.priceListSelected.id,
        season_id: vm.seasonSelected.id,
      };

      // console.log(params); return;

      vm.sendingForm = true;
      HotelPriceService.saveHotelPrices(vm.hotel, params, vm.editMode).then(function (data) {
        if (data) {
          vm.onHotelPricesSaved();

          setItemOptions(data[0].updated_at);

          vm.hotelPrices = data;
          setHotelPricesData();
        }

        vm.sendingForm = false;
      });
    }

    function cancel() {
      vm.onHotelPricesCanceled();
    }
  }
})();
